import React, { useState, useEffect } from "react";
import * as Styled from "./styled";

import { useDispatch, useSelector } from "react-redux";
import { fetchHubDetails } from "../../../../reducers/hub";

import Zone from "./components/Zone";

import info from "./assets/ic-info.svg";
import { BrowserView, MobileView } from "react-device-detect";

function City(props) {
  const dispatch = useDispatch();
  const cityName = useSelector((state) => state.hub.name);
  const zones = useSelector((state) => state.hub.zones);

  useEffect(() => {
    dispatch(fetchHubDetails());
  }, [dispatch]);

  const [selectedZone, setSelectedZone] = useState(null);

  const handleSelectZone = (zone) => {
    if (zone === selectedZone) {
      zone = null;
    }
    setSelectedZone(zone);

    props.onSelectZone(zone ? zone.id : null);
  };

  return (
    <>
      <BrowserView>
        <Styled.Title>{cityName}</Styled.Title>
        <Styled.Spacer />
        <Styled.InfoWrapper>
          <Styled.InfoText>Lands sorted by Zones</Styled.InfoText>
          <Styled.InfoIcon src={info} onClick={() => props.onOpenAbout()} />
        </Styled.InfoWrapper>

        <Styled.Grid>
          {zones.map((zone) => {
            return (
              <Zone
                key={zone.id}
                zone={zone}
                selected={selectedZone ? selectedZone.id === zone.id : false}
                onSelect={(zone) => handleSelectZone(zone)}
              />
            );
          })}
        </Styled.Grid>
      </BrowserView>
      <MobileView>
        <Styled.InfoWrapper>
          <Styled.InfoText>Lands sorted by Zones</Styled.InfoText>
          <Styled.InfoIcon src={info} onClick={() => props.onOpenAbout()} />
        </Styled.InfoWrapper>

        <Styled.Grid>
          {zones.map((zone) => {
            return (
              <Zone
                key={zone.id}
                zone={zone}
                selected={selectedZone ? selectedZone.id === zone.id : false}
                onSelect={(zone) => handleSelectZone(zone)}
              />
            );
          })}
        </Styled.Grid>
      </MobileView>
    </>
  );
}

export default City;
